import LoginModal from "components/modal/LoginModal"
import Layout from 'components/layout/Layout';
import { useAuth } from 'hooks/auth'
import React from "react";
import { ROUTES } from "utils/routes";

function Login() {
  const { user } = useAuth();

  React.useEffect(() => {
    if (user && !!user.email_verified) {
      window.location.pathname = ROUTES.DASHBOARD;
    }
  }, [user]);

  return (
    <Layout>
      <LoginModal />
    </Layout>
  )
}
export default Login;
